import {Link} from 'react-router-dom'
import Facebook from '../assets/facebook.svg'
import Twitter from '../assets/x.svg'
import Instagram from '../assets/instagram.svg'
import SocialLinks from '../data/socialLinks.js'
import Logo from '../assets/nextcastle-logo.png'
import Linkedin from '../assets/linkedin.svg'
import BackToTop from './BackToTop.jsx'
import '../styles/footer.css'
import EmailIcon from '../assets/email-icon.svg'
import TelIcon from '../assets/tel-icon.svg'
import AddressIcon from '../assets/address-icon (2).svg'

function Footer() {
    const getYear = new Date().getFullYear()


    return (
        <div className="footer-container">
            <div className="footer-contents">
            <div className="footer-logo">
                <div className="footer-logo-image">
                <Link to ='/'>
                <img src={Logo} alt="school-help-logo"/></Link>
                </div>
                <div className="footer-logo-text">
                    <p>NEXTCASTLE ENERGY LIMITED is an Oil Services company incorporated in 2006 with its corporate office and fabrication yard in Port Harcourt Nigeria. The philosophy of the company is to provide the client with complete, Quality Oilfield services at competitive prices.</p>
                </div>
            </div>

            <div className="important-links">
                <h3>Important Links:</h3>
                <ul>                          
                    <li> <Link to ="/"> Home </Link></li>                  
                    <li> <Link to ="/Procurement"> Procurement </Link> </li>                  
                    <li> <Link to ="/Construction"> Construction </Link> </li>                  
                    <li> <Link to ="/Engineering"> Engineering </Link> </li>                  
                    <li> <Link to ="/Contracting"> Contracting </Link> </li>                  
                    <li> <Link to ="/Corrosion"> Corrosion </Link> </li>                  
                    {/* <li> <Link to ="/News"> News </Link> </li>                   */}
                    <li> <Link to ="/Contact"> Contact </Link> </li>                  
                                
                                    
                </ul>
            </div>       

            <div className="social-links">
                <h3>Social Links</h3>
                <a href={SocialLinks.facebook}> <img src={Facebook} alt="facebook-logo" /></a>
                <a href={SocialLinks.twitter}> <img src={Twitter} alt="intagram-logo" /></a> 
                <a href={SocialLinks.instagram}> <img src={Instagram}alt="twitter-logo" /></a>
                <a href='#'> <img src= {Linkedin}alt="linkedin" /></a>

            </div>  
     
              
              
            <div className="footer-contact-information">
                <h3>Contact Us:</h3>
                <div className="footer-email-address">
                  <img src={EmailIcon}alt="email-icon" />
                  <a href="mailto:your@email.com?subject=Inquiry&body=Hello, I would like to know more  about...">info@nextcastlegroup.com</a>
                </div>
            <div className="footer-telephone">
                  <img src={TelIcon} alt="tel-icon" />
                  <a href="tel:+1234567890">+234 8022862128</a>
           </div>

           <div className="footer-address">
              <img src={AddressIcon} alt="address" />
              <p>Plot 477 Trans Amadi Industrial Layout, Port Harcourt</p>
           </div>
           <BackToTop/>
           </div>
             
              
          
         
    </div>
         <div className="copy-right">
            <p>Copyright &copy; {getYear} Nextcastle Energy Limited</p>     
            <p>Powered by: <a href="https://pearl-ittech.com/">Pearl-it Technologies</a></p>
          </div>  
     
          
        </div>
    )
}

export default Footer;